import { useTheme } from '@emotion/react';

import {
	MapProductIdMuni,
	MapProductIdLiberec,
	MapProductIdPlzen,
	MapProductIdZlin,
} from 'utils/enumMaps';

const useMapProductId = () => {
	const { university } = useTheme();

	switch (university) {
		case 'MUNI':
			return (id: string) => MapProductIdMuni[id];
		case 'PLZEN':
			return (id: string) => MapProductIdPlzen[id];
		case 'LIBEREC':
			return (id: string) => MapProductIdLiberec[id];
		case 'ZLIN':
			return (id: string) => MapProductIdZlin[id];
	}
};

export default useMapProductId;
